import { GET_PAYROLLS } from "constants/payrolls";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PAYROLLS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
